const PREFIX = "group-order";

export const GROUP_CART_ORDER_DATA_TEST_IDS = {
    BACK_ICON: `${PREFIX}-back-icon`,
    HEADER_TITLE: `${PREFIX}-header-title`,
    HEADER_SUBTITLE: `${PREFIX}-header-subtitle`,
    INVITE_MORE_PILL: `${PREFIX}-invite-more-pill`,
    DELETE_GROUP_PILL: `${PREFIX}-delete-group-pill`,
    LEAVE_GROUP_PILL: `${PREFIX}-leave-group-pill`,
    ITEMS_CONTAINER: `${PREFIX}-items-container`,
    FOOTER: `${PREFIX}-footer`,
    BOTTOMSHEET: `${PREFIX}-bottomsheet`,
    GO_BACK_CTA: `${PREFIX}-go-back-cta`,
    ADD_MORE_ITEMS: `${PREFIX}-add-more-items`,
    NON_EDITABLE_QUANTITY: `${PREFIX}-non-editable-quantity`,
    REFRESH_CTA: `${PREFIX}-refresh-cta`,
    GUEST_BANNER: `${PREFIX}-guest-banner`,
};
